import { Component, OnInit } from '@angular/core';
import { VerskiPraznik} from './verski-praznik';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-verski-praznik',
  templateUrl: './verski-praznik.component.html',
})
export class VerskiPraznikComponent
 extends BaseModalContainer<VerskiPraznik>
 implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<VerskiPraznik>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
   }

  ngOnInit() {
  }

}
